import { styled } from '@mui/material'
import Grid from '@mui/material/Grid2'

export const MessageWrapper = styled(Grid)(({ theme }) => ({
    position: 'relative',
    padding: 16,
    paddingBottom: 8,

    ':hover': {
        button: {
            visibility: 'visible',
        },

        '.message-toolbar-container': {
            opacity: 1,
        },
    },

    [theme.breakpoints.down('md')]: {
        padding: 0,
        marginTop: '8px',

        '.message-toolbar-container': {
            opacity: 1,
        },
    },
}))
